module.exports = __webpack_public_path__ + "static/shickardBanner-09261522eecd83986a3202d3a370dfd5.jpg";